import service from '@/api/service/service';
import qs from "qs";


/**
 * 获取图形验证码
 * @param data - nonce_str timestamp
 */
export function getPhotoCode(data = {}) {
  return service({
    url: "/api/index/create_verify_code.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/**
 * D级成绩查询
 * @param data - nonce_str user_name id_number  verification_code timestamp
 */
export function selectAchievementData(data = {}) {
  return service({
    url: "/api/index/achievement_coach_data.json",
    method: 'post',
    data: qs.stringify(data)
  });
}

/**
 * 获取结果
 * @param puuid
 */
export function uuidGetData(data = {}) {
  return service({
    url: "/api/index/achievement_uuid_data.json",
    method: 'post',
    data: qs.stringify(data)
  });
}
